import React from "react";
import { Dialog, withStyles } from "@material-ui/core";
import "../../../../styles/sharedStyles.scss";
import Grid from "@material-ui/core/Grid";
import Clear from "@material-ui/icons/Clear";
import styles from "./HandOver.module.scss";
import { withTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import UiDateUtils from "../../../../utils/UiDateUtils";
import { HANDOVER_DIALOGUES, HANDOVER_STATUS } from "./Constants";
import CustomerReservationsClient from "../../../../shared/clients/CustomerReservationsClient";

const StyledClear = withStyles({
  root: {
    width: 27,
    height: 27,
    fill: "#102b4e",
    align: "right",
  },
})(Clear);

const StyledDialog = withStyles({
  paper: {
    maxWidth: 607,
    height: 376,
  },
})(Dialog);

class HandOverCompleteConfirmDialog extends React.Component {
  handleClose = () => {
    this.props.handleDialogChange(
      null,
      HANDOVER_DIALOGUES.COMPLETE_CONFIRM,
      HANDOVER_DIALOGUES.COMPLETE
    );
  };

  handleBack = () => {
    this.props.handleDialogChange(
      HANDOVER_DIALOGUES.COMPLETE_CALENDER,
      HANDOVER_DIALOGUES.COMPLETE_CONFIRM
    );
  };

  handleConfirm = () => {
    this.props.handleDialogChange(null, HANDOVER_DIALOGUES.COMPLETE_CONFIRM);
    this.props.hideOrShow(true);
    const handOverData = this.getHandOverData();
    CustomerReservationsClient.updateHandOver(
      this.props.token,
      handOverData,
      this.props.customerReservation.id
    )
      .then(() => {
        this.props.refreshOrderDetails();
      })
      .catch(() => {
        this.props.showErrorPopup(
          this.props.t("Error.processingErrorTitle"),
          this.props.t("Error.processingErrorMessage")
        );
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  formatDate = (handOverCompleteDate) => {
    const year = handOverCompleteDate.getFullYear();
    const month = handOverCompleteDate.getMonth() + 1;
    const day = handOverCompleteDate.getDate();
    return UiDateUtils.formatDateYYYYMMDD(year, month, day);
  };

  getHandOverData() {
    return {
      preferredAppointmentDate: this.formatDate(
        this.props.handOverCompleteDate
      ),
      preferredNotesToDealer: "",
      appointmentStatus: HANDOVER_STATUS.RECEIVED,
      dealerUserId: this.props.user.userId,
      paymentType: this.props.customerReservation.paymentType,
    };
  }

  render() {
    return this.props.open ? (
      <StyledDialog open={this.props.open} onClose={this.handleClose}>
        <div className={styles.dialog}>
          <Grid
            container
            data-testid="handOverCompleteConfirmDialog"
            className={styles.dialogContainer}
            justify="center"
          >
            <Grid item md={12} className={styles.cancel}>
              <div>
                <button
                  data-testid="handOverCompleteConfirmCloseDialog"
                  onClick={this.handleClose}
                >
                  <StyledClear />
                </button>
              </div>
            </Grid>

            <Grid item md={9}>
              <div className={styles.brightRedTitle}>
                <div className={styles.warning} />
                {this.props.t("HandOverCompleteConfirmDialog.title")}
              </div>
            </Grid>

            <Grid item md={9}>
              <div className={styles.body}>
                <div>
                  {this.props.t("HandOverCompleteConfirmDialog.bodyText")}
                </div>
              </div>
            </Grid>

            <Grid item md={9}>
              <div>
                <div className={styles.header}>
                  {this.props.t("HandOverCompleteConfirmDialog.handOverDate")}
                </div>

                <div className={styles.value}>
                  {this.formatDate(this.props.handOverCompleteDate)}
                </div>
              </div>
            </Grid>

            <Grid item md={9}>
              <div className={styles.dialogActions}>
                <Button
                  className={styles.cancel}
                  name="handOverCompleteConfirmBack"
                  data-testid="handOverCompleteConfirmBack"
                  onClick={this.handleBack}
                >
                  {this.props.t("HandOverCompleteConfirmDialog.back")}
                </Button>
                <Button
                  className={styles.next}
                  name="handOverCompleteConfirmNext"
                  data-testid="handOverCompleteConfirmNext"
                  onClick={this.handleConfirm}
                >
                  {this.props.t("HandOverCompleteConfirmDialog.next")}
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </StyledDialog>
    ) : (
      ""
    );
  }
}

export default withTranslation("emp")(HandOverCompleteConfirmDialog);
